"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const ReactDOM = require("react-dom");
const react_redux_1 = require("react-redux");
const actions_1 = require("../../../actions");
const reducers_1 = require("../../../reducers");
const ResponsiveContainer_1 = require("../../utils/ResponsiveContainer");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const MobilePopover_1 = require("./MobilePopover");
const PopoverModalForm = ({ popoverModalProps, popoverNavbarProps, popoverFormInputProps, handleSaveChange, handleShowPopoverForm, children, presentationType, field, addButton, editButton, activePopover, isPopoverModalFormOpen, closePopoverModalForm, openPopoverModalForm, updateActivePopover, device, }) => {
    const handleClosePopoverModal = () => {
        switch (presentationType) {
            case 'popover':
            default:
                updateActivePopover('');
                break;
            case 'modal':
                closePopoverModalForm();
                setTimeout(() => {
                    updateActivePopover('');
                }, 500);
                break;
        }
    };
    const getClickableView = (mode) => {
        const clonedPopoverModalChild = Object.keys(children.props).length === 0
            ? React.cloneElement(children, {
                handleSaveChange: (fieldVal) => handleSaveChange(handleClosePopoverModal, fieldVal),
                key: `${field}_PopoverModalChild`,
            })
            : children;
        switch (presentationType) {
            case 'modal':
                return isPopoverModalFormOpen !== 'close' && field === activePopover
                    ? ReactDOM.createPortal(React.createElement(MobilePopover_1.default, { children: clonedPopoverModalChild, animation: isPopoverModalFormOpen, navbarProps: popoverNavbarProps(handleClosePopoverModal) }), document.getElementById('mainModalLeft'))
                    : null;
            case 'popover':
            default:
                return (React.createElement(src_1.PopoverContainer, { id: `PopoverModalForm_${field}`, popoverProps: popoverModalProps(handleClosePopoverModal), targetParent: device === 'Desktop' ? 'mainModalView' : 'mainModalLeft', onClick: showForm, showPopover: activePopover === field }, [mode === 'add' ? addButton : editButton, clonedPopoverModalChild]));
        }
    };
    const handleOpenModal = () => {
        updateActivePopover(field);
        openPopoverModalForm();
        if (handleShowPopoverForm) {
            handleShowPopoverForm();
        }
    };
    const showForm = () => {
        const activeField = activePopover === field ? '' : field;
        updateActivePopover(activeField);
        if (handleShowPopoverForm) {
            handleShowPopoverForm();
        }
    };
    const getRowOnClickAction = () => {
        switch (presentationType) {
            case 'modal':
                return handleOpenModal;
            case 'popover':
            default:
                return showForm;
        }
    };
    const inputTypeProps = Object.assign(Object.assign({}, popoverFormInputProps), { startEditingText: getRowOnClickAction(), updateText: (fieldVal) => handleSaveChange(handleClosePopoverModal, fieldVal), deleteText: () => handleSaveChange(handleClosePopoverModal, '') });
    return (React.createElement("div", { style: {
            display: 'flex',
            minHeight: 72,
            borderBottom: `1px solid ${src_1.titanium}`,
        }, id: `popoverModal_${field}` },
        React.createElement(src_1.PopoverFormInput, Object.assign({}, inputTypeProps, { addButton: getClickableView('add'), editButton: getClickableView('edit') }))));
};
PopoverModalForm.defaultProps = {
    addButton: React.createElement(src_1.PlusIcon, { fill: src_1.titanium, key: "popoverModalForm1" }),
    editButton: React.createElement(src_1.ChangeIcon, { key: "popoverModalForm1", fill: src_1.titanium }),
};
const mapStateToProps = (state) => ({
    isPopoverModalFormOpen: reducers_1.getIsPopoverModalFormOpen(state),
    activePopover: reducers_1.getActivePopover(state),
});
const mapDispatchToProps = (dispatch) => {
    return {
        openPopoverModalForm: () => {
            dispatch(actions_1.openPopoverModalForm());
        },
        closePopoverModalForm: () => {
            dispatch(actions_1.closePopoverModalForm());
        },
        updateActivePopover: (field) => {
            dispatch(actions_1.updateActivePopover(field));
        },
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)((props) => ResponsiveContainer_1.default(props)(PopoverModalForm));
